export default __webpack_public_path__ + "static/media/lakers-city.6b8a758f.jpeg";